package fr.manyverse.app.presentation.theme

import androidx.compose.material3.ColorScheme
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.luminance

/**
 * Couleurs sémantiques absentes du ColorScheme Material 3 (pas de token « success »).
 *
 * Le mode clair/sombre est déduit de la luminance de [ColorScheme.surface], comme dans
 * [fr.manyverse.app.presentation.components.soundboard.soundTagPalette]. On évite ainsi de
 * coder une couleur en dur côté UI : les états de réussite (lancer de dé réussi, digicode /
 * crochetage validé, choix de personnage confirmé) s'adaptent au thème actif.
 */
private val ColorScheme.isLight: Boolean
    get() = surface.luminance() > 0.5f

val ColorScheme.success: Color
    get() = if (isLight) Color(0xFF2E7D32) else Color(0xFF81C784)

val ColorScheme.onSuccess: Color
    get() = if (isLight) Color(0xFFFFFFFF) else Color(0xFF00390F)

val ColorScheme.successContainer: Color
    get() = if (isLight) Color(0xFFB6F2B6) else Color(0xFF1B5E20)

val ColorScheme.onSuccessContainer: Color
    get() = if (isLight) Color(0xFF002106) else Color(0xFFB6F2B6)
